module.exports = __webpack_public_path__ + "img/chat2desk.1abbca8d.png";